




































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ProductServerLocation } from '../../../store/product/types';

@Component
export default class CheckoutLocationItem extends Vue {
  @Prop({ required: true, type: Object }) readonly location!: ProductServerLocation;

  @Prop({ required: false, type: Object }) readonly selectedLocation!: ProductServerLocation;

  get locationImage(): string {
    return `${process.env.VUE_APP_CDN_URL}`.concat('/flags/').concat(this.location.countryCode.toLowerCase()).concat('.webp');
  }

  get locationElementKey(): string {
    return `location-${this.location.key}`;
  }

  get locationElementValue(): string {
    return this.location.key;
  }
}
